export default {
    feedAssignmentQueue(state) {
        const assignmentQueue = { ...state.feedAssignmentQueue };

        for (const index in assignmentQueue) {
            if (assignmentQueue[index].isCurrentQueue) {
                if (!assignmentQueue[index].name.includes("(aktif)")) {
                    assignmentQueue[index].name += " (aktif)";

                    break;
                }
            }
        }

        return assignmentQueue;
    },
    feedAssignmentQueueTable(state) {
        const assignmentQueue = state.feedAssignmentQueue ? state.feedAssignmentQueue.slice(0, 5) : [];

        return assignmentQueue;
    }
}